import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import { StudioLayout } from "@/layouts/StudioLayout";
import { Dashboard } from "@/pages/Dashboard";
import { Studio } from "@/pages/Studio";
import { Broadcasts } from "@/pages/Broadcasts";
import { Recordings } from "@/pages/Recordings";
import { SocialComposer } from "@/pages/SocialComposer";
import { Settings } from "@/pages/Settings";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Dashboard routes */}
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/broadcasts" element={<Broadcasts />} />
            <Route path="/recordings" element={<Recordings />} />
            <Route path="/social" element={<SocialComposer />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          
          {/* Studio route (full screen) */}
          <Route path="/studio" element={<StudioLayout />}>
            <Route index element={<Studio />} />
            <Route path=":streamId" element={<Studio />} />
          </Route>
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
